/**
 * @generated SignedSource<<0d4369f19f2aa2d86b1af0d493510b82>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
export type JiraForgeEnvironmentType = "DEVELOPMENT" | "PRODUCTION" | "STAGING" | "%future added value";
export type JiraVisibilityControlMechanism = "AppAccessRules" | "DisplayConditions" | "UnlicensedAccess" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type fragment_AtlassianUiModificationsCore_RootFragment$data = {
  readonly jira: {
    readonly forge: {
      readonly uiModificationsExtensions: ReadonlyArray<{
        readonly appVersion: string;
        readonly consentUrl: string | null | undefined;
        readonly egress: ReadonlyArray<{
          readonly addresses: ReadonlyArray<string> | null | undefined;
          readonly category: string | null | undefined;
          readonly inScopeEUD: boolean | null | undefined;
          readonly type: string | null | undefined;
        } | null | undefined>;
        readonly environmentId: string;
        readonly environmentKey: string;
        readonly environmentType: JiraForgeEnvironmentType;
        readonly hiddenBy: JiraVisibilityControlMechanism | null | undefined;
        readonly id: string;
        readonly installationConfig: ReadonlyArray<{
          readonly key: string;
          readonly value: boolean;
        }> | null | undefined;
        readonly installationId: string;
        readonly license: {
          readonly active: boolean;
          readonly billingPeriod: string | null | undefined;
          readonly capabilitySet: string | null | undefined;
          readonly ccpEntitlementId: string | null | undefined;
          readonly ccpEntitlementSlug: string | null | undefined;
          readonly isEvaluation: boolean | null | undefined;
          readonly subscriptionEndDate: AGG$DateTime | null | undefined;
          readonly supportEntitlementNumber: string | null | undefined;
          readonly trialEndDate: AGG$DateTime | null | undefined;
          readonly type: string | null | undefined;
        } | null | undefined;
        readonly properties: AGG$JSON;
        readonly scopes: ReadonlyArray<string>;
        readonly type: string;
        readonly userAccess: {
          readonly enabled: boolean;
          readonly hasAccess: boolean;
        } | null | undefined;
      }>;
    } | null | undefined;
    readonly uiModifications: ReadonlyArray<{
      readonly appEnvId: string;
      readonly uiModifications: ReadonlyArray<{
        readonly data: string | null | undefined;
        readonly id: string;
      }>;
    }>;
  } | null | undefined;
  readonly " $fragmentType": "fragment_AtlassianUiModificationsCore_RootFragment";
};
export type fragment_AtlassianUiModificationsCore_RootFragment$key = {
  readonly " $data"?: fragment_AtlassianUiModificationsCore_RootFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"fragment_AtlassianUiModificationsCore_RootFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "id"
},
v1 = {
  "kind": "ScalarField",
  "name": "type"
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "cloudId"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "forgeExtensionRenderingContext"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "uiModificationsContext"
    }
  ],
  "kind": "Fragment",
  "name": "fragment_AtlassianUiModificationsCore_RootFragment",
  "selections": [
    {
      "concreteType": "JiraQuery",
      "kind": "LinkedField",
      "name": "jira",
      "plural": false,
      "selections": [
        {
          "kind": "RequiredField",
          "field": {
            "args": [
              {
                "kind": "Variable",
                "name": "context",
                "variableName": "uiModificationsContext"
              }
            ],
            "concreteType": "JiraAppUiModifications",
            "kind": "LinkedField",
            "name": "uiModifications",
            "plural": true,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "appEnvId"
              },
              {
                "concreteType": "JiraUiModification",
                "kind": "LinkedField",
                "name": "uiModifications",
                "plural": true,
                "selections": [
                  (v0/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "data"
                  }
                ]
              }
            ]
          },
          "action": "NONE",
          "path": "jira.uiModifications"
        },
        {
          "concreteType": "JiraForgeQuery",
          "kind": "LinkedField",
          "name": "forge",
          "plural": false,
          "selections": [
            {
              "kind": "RequiredField",
              "field": {
                "alias": "uiModificationsExtensions",
                "args": [
                  {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                  },
                  {
                    "kind": "Variable",
                    "name": "context",
                    "variableName": "forgeExtensionRenderingContext"
                  },
                  {
                    "kind": "Literal",
                    "name": "types",
                    "value": [
                      "jira:uiModifications"
                    ]
                  }
                ],
                "concreteType": "JiraForgeExtension",
                "kind": "LinkedField",
                "name": "extensions",
                "plural": true,
                "selections": [
                  (v0/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "appVersion"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "installationId"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "environmentId"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "environmentType"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "environmentKey"
                  },
                  {
                    "concreteType": "JiraForgeExtensionLicense",
                    "kind": "LinkedField",
                    "name": "license",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "active"
                      },
                      (v1/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "supportEntitlementNumber"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "trialEndDate"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "subscriptionEndDate"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "isEvaluation"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "billingPeriod"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "ccpEntitlementId"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "ccpEntitlementSlug"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "capabilitySet"
                      }
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "name": "properties"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "scopes"
                  },
                  (v1/*: any*/),
                  {
                    "concreteType": "JiraForgeAppEgressDeclaration",
                    "kind": "LinkedField",
                    "name": "egress",
                    "plural": true,
                    "selections": [
                      (v1/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "addresses"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "category"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "inScopeEUD"
                      }
                    ]
                  },
                  {
                    "concreteType": "JiraForgeInstallationConfigExtension",
                    "kind": "LinkedField",
                    "name": "installationConfig",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "key"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "value"
                      }
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "name": "consentUrl"
                  },
                  {
                    "concreteType": "JiraUserAppAccess",
                    "kind": "LinkedField",
                    "name": "userAccess",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "hasAccess"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "enabled"
                      }
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "name": "hiddenBy"
                  }
                ]
              },
              "action": "NONE",
              "path": "jira.forge.uiModificationsExtensions"
            }
          ]
        }
      ]
    }
  ],
  "type": "Query"
};
})();

(node as any).hash = "ff48dbe4ed2ab636d857ff6d8fc8b30f";

export default node;
